import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import {pickImageStyle} from "@/utils/transforms";
import Image from "next/image";

const useStyles = makeStyles((theme) => ({
    imgStyles: {
      maxWidth: '450px',
      width: '100%',
      height: 'auto',
      minHeight: 250,
      objectFit: 'cover',
      objectPosition: 'center center',
    },
  }),
);

const HomesiteTeaser = (props) => {
  const classes = useStyles(props);
  const {node, noLink} = props;
  let {
    imgAlt,
    imgWidth,
    imgHeight,
    imageOrig,
    image_styles,
    imgTitle,
    headline,
    price,
    address,
    url,
    internal,
    alias,
    title
  } = node;

  if (node?.sfhouse?.id) {
    ({address} = node.sfhouse);
  }

  let getImageStyle = pickImageStyle({
      imgAlt,
      imgTitle,
      imgWidth,
      imgHeight,
      imageOrig,
      image_styles,
      title: 'Media'
    },
    'max_510_height', process.env.NEXT_PUBLIC_FRONT_URL + '/assets/placeholder.jpg');
  ({imgAlt, imgTitle, imgWidth, imgHeight, imageOrig} = getImageStyle);

  imgAlt = imgAlt ? imgAlt : address;
  imgTitle = imgTitle ? imgTitle : address;

  // let alias = node.alias?.alias ? node.alias.alias : '';
  let list_url = alias?.alias || alias || internal;

  return (
    <Link href={list_url}>
      <Box textAlign='center' mt={1} mb={4}>
        {imageOrig &&
        <Image style={{ width: '100%', height: 'auto' }} sizes="30vw" height="300" className={classes.imgStyles} src={imageOrig}
             title={imgTitle} alt={imgAlt}/>
        }
        {headline?.length > 0 &&
        <Typography align={`center`} color='primary' variant='body2'
                    component='p'>{headline}
        </Typography>
        }
        {(address?.length > 0 || title) &&
        <Typography align={`center`} color='primary' variant='body2' component='p'>
          { address?.length > 0 ? address : title }
        </Typography>
        }
      </Box>
    </Link>
  );
};

export default HomesiteTeaser;
